<template>
  <div>
    <modal
      class="output_options-modal"
      width="460px"
      height="130px"
      :backdrop="false"
      :value="showModal"
      effect="fade"
      @closed="closed"
      large
    >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center>
            <strong>{{textTitle}}</strong>
          </center>
        </h4>
      </div>
      <div
        class="modal-body output_options-modal-body"
        style="height: 50px;padding: 0px 15px; overflow-x: auto;"
      >
        <input
          ref="local_value"
          style="margin-top:10px;"
          type="text"
          class="form-control"
          v-on:input="updateValue($event.target.value)"
          id="local_value"
          name="local_value"
          v-bind:value="localValue"
          @keyup="keyUp($event.target.id,$event.target.value, $event)"
          placeholder
        />
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" class="btn btn-default" @click="closed('no')">キャンセル</button>
        <button type="button" class="btn btn-primary" @click="closed('yes')">完了</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import modal from "./local-modal";

Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_input_manual = debug("esma:input-modal");

export default {
  data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: "",
    };
  },
  computed: {
    localValue: {
      get() {
        return this.local_value;
      },
      set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      },
    },
    pageID() {
      return this.$props.pageid;
    },
    textTitle() {
      return this.title_label;
    },
    showModal() {
      return this.show_modal;
    },
  },
  methods: {
    keyUp(id, value, event) {
      if (event.key == "Enter" || event.keyIdentifier == "Enter") {
        this.closed("yes");
      }
    },
    updateValue(val) {
      this.localValue = val;
      // this.$emit('inputed', this.localValue);
    },
    onShow() {},
    showModalWindow(data) {
      debug_input_manual("showModalWindow data", data);
      this.onShow();
      this.title_label = data.title;
      this.localValue = data.initial_value || "";
      this.show_modal = true;
      // this.$emit('inputed', this.localValue);
      this.$refs.local_value.focus();
      setTimeout(() => {
        this.$refs.local_value.focus();
      }, 100);
    },
    closed(mode) {
      debug_input_manual("mode", mode);
      this.$emit("closed", { mode: mode, value: this.localValue });
      this.show_modal = false;
    },
  },
  props: {
    tag: { type: String, default: "showInputModal" },
    pageid: { type: String },
  },
  mounted() {
    debug_input_manual("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
};
</script>
<style scoped>
.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// input-modal2.vue?3206c3c7